import styled from 'styled-components'

const Style = {
	Wrapper: styled.div`
		display: flex;
		align-items: center;
		gap: 8px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			flex-direction: column;
			gap: 16px;
		}
		
	`,
	DivContainer: styled.div`
		display: flex;
		align-items: center;
		gap: 8px;

		& > select {
			padding: 8px 16px;
			flex-grow: 1;
			width: 120px;
			${({theme}) => theme.font.extra_small};
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
		}

		& > input {
			padding: 8px 16px;
			flex-grow: 1;
			width: 100px;
			${({theme}) => theme.font.extra_small};
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				width: 80px;
			}
		}

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			gap: 4px;
		}
	`
}
export default Style
